import {
    DisplayOption,
    FullLayoutItem,
    LayoutPackageDetails,
    MultiFormateRelationMap,
    SingleFormateRelationMap,
    StyleSlug,
} from '@/types/pages/layout';

export type Dialogs = {
    saveAs: boolean;
    regenerate: boolean;
    previewError: boolean;
    new: boolean;
    edit: boolean;
    deleteAll: boolean;
};
export type Loadings = {
    saveAs: boolean;
    regenerate: boolean;
    export: boolean;
    save: boolean;
    layout: boolean;
    category: boolean;
};
export type LayoutById = Record<string, FullLayoutItem>;

export enum LAYOUT_TYPE {
    SINGLE = 'SINGLE',
    MULTI = 'MULTI',
}

export type LayoutSingle = {
    displayType: string;
    initialRelations: SingleFormateRelationMap;
    relations: SingleFormateRelationMap;
    initialLayoutsById: LayoutById;
    layoutsById: LayoutById;
    styleId: number | null;
    searchSub: string;
    selectedLayouts: string[];
    selectedColors: string[];
    selectedSizes: string[];
    editLayout: FullLayoutItem | null;
};
export type LayoutMulti = {
    displayType: string;
    initialRelations: MultiFormateRelationMap;
    relations: MultiFormateRelationMap;
    initialLayoutsById: LayoutById;
    layoutsById: LayoutById;
    styleId: number | null;
    styleSlug: StyleSlug | null;
    searchSub: string;
    selectedLayouts: string[];
    selectedColors: string[];
    editLayout: FullLayoutItem | null;
};
export type PackageInfo = {
    lp_name: string | null;
    lp_version: number | null;
    has_package: boolean;
};
export type LayoutDefault = {
    currentTab: LAYOUT_TYPE;
    previewBarcode: string;
    layoutInfo: LayoutPackageDetails | null;
    packageInfo: PackageInfo | null;
    previewError: {
        key: string;
        message: string;
    }[];
    packageName: string;
    saveAsName: string;
    dialogs: Dialogs;
    loadings: Loadings;
    displayOptions: DisplayOption[];
    isDirty: boolean;
    single: LayoutSingle;
    multi: LayoutMulti;
};
export const defaultState: LayoutDefault = {
    currentTab: LAYOUT_TYPE.SINGLE,
    previewBarcode: '',
    layoutInfo: null,
    packageInfo: null,
    packageName: '',
    saveAsName: '',
    previewError: [],
    displayOptions: [],
    isDirty: false,
    dialogs: {
        saveAs: false,
        regenerate: false,
        previewError: false,
        new: false,
        edit: false,
        deleteAll: false,
    },
    loadings: {
        saveAs: false,
        regenerate: false,
        export: false,
        save: false,
        layout: true,
        category: false,
    },
    single: {
        displayType: '',
        initialRelations: {},
        relations: {},
        initialLayoutsById: {},
        layoutsById: {},
        styleId: null,
        searchSub: '',
        selectedLayouts: [],
        selectedColors: [],
        selectedSizes: [],
        editLayout: null,
    },
    multi: {
        displayType: '',
        initialRelations: {},
        relations: {},
        initialLayoutsById: {},
        layoutsById: {},
        styleId: null,
        styleSlug: null,
        searchSub: '',
        selectedLayouts: [],
        selectedColors: [],
        editLayout: null,
    },
};
